import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Commodity } from '../../../hooks'
import { type Option } from '../../common/Form/types'
import {
    SelectFilter,
    SelectFilterProps,
} from '../../common/Filter/SelectFilter/SelectFilter'
import { FilterProps } from '../../common/Filter/types'
import { useFilterLabels } from './useFilterLabels'

export type UnitOfMeasureFilterProps = {
    name: string
    onChange: (uoms: string[]) => void
    value: string[]
    defaultValue: string[]
    disabled?: boolean
    valueLabel?: string
    multiple?: boolean
    selectedCommodityTypeId: number
    commodities?: Commodity[]
    isError?: boolean
    isLoading?: boolean
} & Pick<FilterProps, 'containerRef'>

export const UnitOfMeasureFilter: React.FC<UnitOfMeasureFilterProps> = ({
    disabled,
    value,
    defaultValue,
    name,
    multiple,
    selectedCommodityTypeId,
    onChange,
    valueLabel,
    containerRef,
    commodities,
    isError,
    isLoading,
}) => {
    const { t } = useTranslation('translations')

    const labels = useFilterLabels()

    const selectedCommodity = React.useMemo(() => {
        return commodities?.find(
            (c: Commodity) => c.commodityTypeId === selectedCommodityTypeId
        )
    }, [selectedCommodityTypeId, commodities])

    const options: Option[] | undefined = selectedCommodity?.unitsOfMeasure.map(
        (uom) => ({
            value: uom.unitOfMeasureId.toString(),
            label: uom.unit,
        })
    )

    const passedProps: SelectFilterProps = {
        multiple,
        name,
        disabled: !!disabled || !selectedCommodityTypeId,
        onChange,

        config: {
            value,
            options,
        },
        value,
        defaultValue,
        label: t('filters.unit_of_measure.label'),
        ...labels,
        isLoading,
        isError,
        valueLabel,
        containerRef,
        required: true,
    }

    return <SelectFilter {...passedProps} />
}
